
































































































































































































































































































































































import { Component, Prop, mixins, Emit, Watch } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import OtherModelDetails from './OtherModelDetails.vue'
import AttributeDetails from './AttributeDetails.vue'
import PlanDetailRange from '~/components/sales_map_v3/PlanDetailRange.vue'
import SalesTeamDetails from '~/components/sales_map_v3/SalesTeamDetails.vue'
import DirectionsMap from '~/components/consumer_map/DirectionsMap.vue'
import VirtualTourWrapper from '~/components/shared/VirtualTourWrapper.vue'
import ImagesGallery from '~/components/shared/imagesGallery.vue'
import PlanCardV3 from '~/components/sales_map_v3/PlanCardV3.vue'
import ElevationCardV3 from '~/components/consumer_map_v3/ElevationCardV3.vue'
import DotFlashing from '~/components/shared/DotFlashing.vue'
import LotInfo from '~/models/lotInfo'
import { PublicProject } from '~/models/project'
import Plan from '~/models/plan'
import Lot from '~/models/lot'
import projectConfig from '~/assets/project-config.json'
import {
  streetViewMetadata,
  EMBED_BASE_URL,
  STREET_VIEW,
} from '~/api/gmaps.api'
import { LotTypes } from '~/enums/lots'
import globalStyling from '~/mixins/globalStyling'
import LotUtilsMixin from '~/mixins/LotUtilsMixin'
import { getElevations } from '~/api/elevations.api'
import { Elevation } from '~/models'
import { parseHomeParams } from '~/api/consumer_map.api'
import { getPublicPlans } from '~/api/plans.api'
import 'swiper/css/swiper.css'
import { ElevationStatus } from '~/enums/construction'
import { checkHideHomePricing } from '~/utils/plans'

@Component({
  components: {
    Swiper,
    SwiperSlide,
    VirtualTourWrapper,
    DirectionsMap,
    ImagesGallery,
    PlanCardV3,
    ElevationCardV3,
    PlanDetailRange,
    OtherModelDetails,
    SalesTeamDetails,
    DotFlashing,
    AttributeDetails,
  },
  mixins: [globalStyling, LotUtilsMixin],
  computed: {
    ...mapGetters('consumer-map', {
      isConsumerMapPlansDisabled: 'isConsumerMapPlansDisabled',
    }),
  },
})
export default class HomesiteSidePanel extends mixins(
  globalStyling,
  LotUtilsMixin
) {
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: null }) model: Lot
  @Prop({ default: null }) filters: any
  @Prop({ default: null }) selectedPlanId: number
  @Prop({ default: null }) selectedElevationId: number
  @Prop({ default: null }) sideModalNavHeight: number

  activeTab: number = 0
  tabs = ['Photos', 'Floor Plan', 'Navigation', 'Virtual Tour', 'Google Street']

  showVirtualTour: boolean = false
  currentSlideImage: number = 1
  streetViewMeta = { status: 'ZERO_RESULTS' }
  lotType: string = LotTypes.HOME
  elevations: Array<Elevation> = []

  isSaved: Boolean = false
  showShareModal: Boolean = false
  sharedUrl: string = ''

  // ---------------
  plans: Array<Plan> = []
  plansLoading: boolean = false
  planSelected: Plan = null
  planSelectorHeight: string = null
  filterNavbarHeight: number = null
  propertyListNavbarHeight: number = 40
  resizeWindowListener: any
  elevationsLoading: boolean = false
  elevationSelected: Elevation = null
  isConsumerMapPlansDisabled: string
  sectionOrder: { [key: string]: number } = {
    planDetail: 1,
    homePlan: 2,
    elevation: 3,
    interiorPhotos: 4,
    otherModel: 5,
    salesTeam: 6,
    imageTourStreet: 7,
    lotAttributes: 9,
    spacer: 10,
  }

  created() {
    this.lotType = this.getLotType(this.project, this.lotInfo)
    window.addEventListener('resize', this.setWindowSize)
    this.setWindowSize()
  }

  mounted(): void {
    this.getPlans()
    this.setSectionOrder()
  }

  beforeDestory(): void {
    window.removeEventListener('resize', this.setWindowSize)
  }

  async getPlans(): Promise<void> {
    try {
      this.plansLoading = true
      const queryParams = {
        lotId: this.lotInfo.id,
        pageSize: 'max',
        available: true,
        masterPlan: this.useCondoMasterPlan,
        ordering: this.plansOrdering,
      }
      const response = await getPublicPlans(queryParams)
      this.plans = response?.data?.results || []

      if (this.selectedPlanId) {
        this.onPlanSelection(this.selectedPlanId, this.selectedElevationId)
      } else if (this.plans.length === 1) {
        this.onPlanSelection(this.plans[0].id)
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.plansLoading = false
      if (this.planSelected) {
        this.$nextTick(() => {
          this.scrollToElement('interiorPhotos')
        })
      }
    }
  }

  async getElevations(
    planId: number,
    selectedElevationId: number | null = null
  ): Promise<void> {
    this.elevationsLoading = true
    const filtersApplied = { ...this.filters }
    if (filtersApplied.builder) {
      delete filtersApplied.builder
    }

    try {
      const response = await getElevations(
        null,
        this.lotInfo?.id,
        null,
        null,
        'max',
        null,
        this.$route.params.slug,
        this.lotInfo?.builder?.id,
        false,
        planId,
        parseHomeParams(filtersApplied),
        false // turn off AM check for this elevations call
      )
      this.elevations = response.results

      if (selectedElevationId) {
        this.onElevationSelection(selectedElevationId)
      }
    } catch (error) {
      throw new Error(error)
    } finally {
      this.elevationsLoading = false
    }
  }

  get applicableElevations() {
    return this.elevations.filter(
      (elevation) =>
        this.planSelected.id === elevation.plan.id &&
        elevation.status === ElevationStatus.APPROVED
    )
  }

  get beds() {
    return this.planSelected ? this.planSelected.beds : this.min('beds')
  }

  get max_beds() {
    return this.planSelected ? this.planSelected.max_beds : this.max('max_beds')
  }

  get baths() {
    return this.planSelected ? this.planSelected.baths : this.min('baths')
  }

  get max_baths() {
    return this.planSelected
      ? this.planSelected.max_baths
      : this.max('max_baths')
  }

  get garage() {
    return this.planSelected ? this.planSelected.garage : this.min('garage')
  }

  get max_garage() {
    return this.planSelected
      ? this.planSelected.max_garage
      : this.max('max_garage')
  }

  get stories() {
    return this.planSelected ? this.planSelected.stories : this.min('stories')
  }

  get max_stories() {
    return this.planSelected ? this.planSelected.stories : this.max('stories')
  }

  formatSqft(sqft: number) {
    return String(sqft).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  get sqft() {
    if (this.planSelected && this.planSelected.sqft) {
      return this.formatSqft(this.planSelected.sqft)
    } else if (this.lotInfo.sqft && this.lotInfo.sqft !== '-') {
      return this.lotInfo.sqft
    } else {
      return this.formatSqft(this.min('sqft'))
    }
  }

  get max_sqft() {
    if (this.planSelected && this.planSelected.sqft) {
      return this.formatSqft(this.planSelected.sqft)
    } else if (this.lotInfo.sqft && this.lotInfo.sqft !== '-') {
      return this.lotInfo.sqft
    } else {
      return this.formatSqft(this.max('sqft'))
    }
  }

  get acreage() {
    return this.lotInfo.acreage || '-'
  }

  min(param: string) {
    return this.plans.length
      ? Math.min(...this.plans.map((plan) => plan[param]))
      : 0
  }

  max(param: string) {
    return this.plans.length
      ? Math.max(...this.plans.map((plan) => plan[param]))
      : 0
  }

  get plansOrdering() {
    const customOrderingParam = this.getStyleVariableValue(
      '--cm-sp-order-plans-by'
    )?.replace(/['"]+/g, '')

    if (customOrderingParam) {
      return customOrderingParam + ',' + 'id'
    }
    return 'id'
  }

  get useCondoMasterPlan() {
    if (this.lotInfo?.property_type === 'Condo') {
      return (
        this.getStyleVariableValue('--ad-sp-condo-master-plan')?.replace(
          /['"]+/g,
          ''
        ) === 'true'
      )
    }
    return false
  }

  get floorPlanImages() {
    if (this.planSelected) {
      return this.planSelected.floor_plan_images.map((img) => img.source)
    } else {
      return []
    }
  }

  get displayInteriorPhotoTitle() {
    return this.isVisible('--ad-sp-hs-interior-photo-title')
  }

  get displayInteriorPhotos() {
    return (
      this.getStyleVariableValue('--ad-sp-hs-display-interior-photos')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get showStreetView() {
    return (
      this.getStyleVariableValue('--ad-sp-hs-google-street-view')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get interiorElevationImages(): Array<string> {
    let images: string[] = []
    if (this.lotInfo?.photo_management_gallery?.length > 0) {
      return this.lotInfo.photo_management_gallery.map(
        (photo: any) => photo.source
      )
    }
    if (this.planSelected) {
      const interiorImages = this.planSelected.elevation_photos.map(
        (img) => img.source
      )
      const elevationImages = this.planSelected.interior_photos.map(
        (img) => img.source
      )
      images = [...interiorImages, ...elevationImages]
    }
    return images
  }

  get elevationBypassed() {
    return (
      this.getStyleVariableValue('--ad-sp-hs-bypass-elevations')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get hideBuilder() {
    return (
      this.getStyleVariableValue('--ad-sp-hs-hide-builder')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get displayAttributes() {
    return (
      this.getStyleVariableValue('--ad-sp-display-attributes')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    )
  }

  get showImageTourStreet() {
    return (
      (this.elevationSelected || this.elevationBypassed) &&
      this.planSelected &&
      !this.isMapPlansDisabled
    )
  }

  get showPlanDescription() {
    if (this.planSelected && this.planSelected.description) {
      return (
        this.getStyleVariableValue('--ad-sp-hs-plan-description')?.replace(
          /['"]+/g,
          ''
        ) === 'true'
      )
    }
  }

  get descriptionHeader() {
    const isDescriptionPrimary = this.isVisible(
      '--ad-sp-description-primary-heading'
    )
    return isDescriptionPrimary
      ? 'sm:text-xl font-brand-primary text-brand-base-300 font-bold'
      : 'text-justify font-light font-brand-primary text-brand-base text-base'
  }

  get descriptionText() {
    const isDescriptionPrimary = this.isVisible(
      '--ad-sp-description-primary-heading'
    )
    return isDescriptionPrimary
      ? 'text-sm text-left font-brand-secondary text-brand-base'
      : 'mt-2 font-brand-secondary text-brand-base'
  }

  async handleInfoCardClick(planId: any) {
    await this.onPlanSelection(planId)
    this.scrollToElement('interiorPhotos')
  }

  scrollToElement(elementId: string) {
    if (!this.isVisible('--cm-sp-autoscroll-on-model-select')) return
    const element = this.$refs[elementId] as HTMLElement
    const container = this.$refs.planFinder as HTMLElement
    const offset = this.filterNavbarHeight + this.propertyListNavbarHeight

    if (element && container) {
      container.scrollTo({
        behavior: 'smooth',
        top: element.offsetTop - offset,
      })
    }
  }

  @Emit('planSelection')
  onPlanSelection(
    planId: number,
    elevationId: number | null = null
  ): { id: number; name: string; sqft: number; price: string } {
    this.elevationSelected = null
    if (this.planSelected && planId === this.planSelected.id) {
      this.planSelected = null
      return null
    } else {
      this.planSelected = this.plans.find((plan) => plan.id === planId)
      this.getElevations(planId, elevationId)
      const scrollElement = document.querySelector('#plan-finder')
      const exteriorOptionsElement = document.querySelector('#choose-exterior')
      if (exteriorOptionsElement) {
        const exteriorOptionsElementRect =
          exteriorOptionsElement.getBoundingClientRect()
        scrollElement.scrollBy({
          top: exteriorOptionsElementRect.bottom - 150,
          behavior: 'smooth',
        })
      }

      if (this.planSelected) {
        return {
          id: this.planSelected.id,
          name: this.planSelected.name,
          sqft: this.planSelected.sqft,
          price: this.planSelected.price,
        }
      }
    }
  }

  @Emit('elevationSelection')
  onElevationSelection(value: number): {
    id: number
    name: string
    slug: string
  } {
    if (
      this.elevationSelected === null ||
      this.elevationSelected.id !== value
    ) {
      this.elevationSelected = this.elevations.find(
        (elevation) => elevation.id === value
      )
    } else {
      this.elevationSelected = null
    }
    return this.elevationSelected
      ? {
          id: this.elevationSelected.id,
          name: this.elevationSelected.name,
          slug: this.elevationSelected.slug,
        }
      : null
  }

  private async getStreetViewMetadata(lotInfo: LotInfo) {
    this.streetViewMeta = await streetViewMetadata(
      lotInfo.latitude,
      lotInfo.longitude,
      process.env.mapApiKey
    )
  }

  get builderImg() {
    return this.lotInfo.builder.logo || this.project.logo
  }

  @Watch('sideModalNavHeight', { immediate: true, deep: true })
  onSideModalNavHeightChange() {
    this.setWindowSize()
  }

  setWindowSize() {
    this.filterNavbarHeight = this.calculateFilterNavbarHeight()

    const offset =
      this.filterNavbarHeight +
      this.propertyListNavbarHeight +
      this.sideModalNavHeight

    this.planSelectorHeight = `calc(100vh - ${offset}px)`
  }

  calculateFilterNavbarHeight() {
    const screenWidth = window.innerWidth
    if (screenWidth > 600 && screenWidth < 1024) {
      return 40
    }
    return 56
  }

  get customPriceLabel(): string {
    if (this.lotInfo?.property_type === 'Condo') {
      const label = projectConfig[this.$route.params.slug]?.condoPriceLabel
      if (label) return label
    }
    if (this.lotType === LotTypes.HOME_SITE)
      return (
        projectConfig[this.project.slug]?.homesitePriceLabel || 'Starting Price'
      )

    return projectConfig[this.project.slug]?.homePriceLabel || 'Listing Price'
  }

  get priceDetailsLabel(): string {
    if (this.lotInfo?.property_type === 'Condo') {
      return (
        projectConfig[this.$route.params.slug]?.condoDetailsPriceLabel ||
        'Starting Price'
      )
    }
    return 'Starting Price'
  }

  get virtualTourTitle(): string {
    const label = this.getStyleVariableValue(
      '--cm-hs-sp-3d-tour-label'
    )?.replace(/['"]+/g, '')

    return label || '3D Tour (based on Home Plan selection)'
  }

  get virtualTour(): string {
    return this.planSelected?.virtual_tour_url || null
  }

  setActiveTab(index: number = 0): void {
    this.activeTab = index
  }

  setShowVirtualTour(value: boolean): void {
    this.showVirtualTour = value
  }

  get gStreetMapUrl(): string {
    return `${EMBED_BASE_URL}${STREET_VIEW}?key=${process.env.mapApiKey}&location=${this.lotInfo.latitude},${this.lotInfo.longitude}&heading=236`
  }

  get priceToDisplay(): number {
    if (this.planSelected) {
      return parseInt(this.planSelected.price)
    } else {
      const value = this.plans.map((plan) => parseInt(plan.price))
      return value.length ? Math.min(...value) : 0
    }
  }

  get hideHomePricing(): boolean {
    return this.plans.some((plan) => checkHideHomePricing(plan))
  }

  get customNoPlansLabel(): string {
    return (
      projectConfig[this.$route.params.slug]?.noPlansLabel || 'No plans found!'
    )
  }

  get isMapPlansDisabled() {
    return this.isConsumerMapPlansDisabled === 'true'
  }

  get homesitePlanText() {
    return this.getStyleVariableValue(
      '--cm-sp-homesite-select-plan-label'
    )?.replace(/['"]+/g, '')
  }

  get homesitePlanSubtext() {
    return this.getStyleVariableValue(
      '--cm-sp-homesite-select-plan-subtext'
    )?.replace(/['"]+/g, '')
  }

  get reorderPlanDetail() {
    return this.isVisible('--ad-sp-hs-reorder-plan-detail')
  }

  get displayPlanDetail() {
    if (this.isVisible('--ad-sp-hide-plan-detail-wo-plan')) {
      return this.planSelected
    }
    return true
  }

  setSectionOrder() {
    if (this.reorderPlanDetail) {
      this.sectionOrder.planDetail = this.sectionOrder.imageTourStreet + 1
    }
  }
}
